
import { DeviceCommandsContent } from "./DeviceCommandsContent";

interface Device {
  id: string;
  name: string;
  user: string;
  os: string;
  version: string;
  status: "active" | "prepared" | "inactive" | "registered" | "in_process";
  lastSync: string;
  group: string;
}

interface DeviceCommandsTabProps {
  device: Device;
}

export const DeviceCommandsTab = ({ device }: DeviceCommandsTabProps) => {
  if (device.status === "registered" || device.status === "prepared") {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <p className="text-muted-foreground text-lg">Not available</p>
          <p className="text-sm text-muted-foreground mt-2">
            Commands are only available when the device is active
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-full overflow-y-auto p-4 px-6">
      <DeviceCommandsContent device={device as any} activeSection="combined" />
    </div>
  );
};
